import { render, staticRenderFns } from "./POSDefaults.vue?vue&type=template&id=e541fcaa"
import script from "./POSDefaults.vue?vue&type=script&lang=js"
export * from "./POSDefaults.vue?vue&type=script&lang=js"
import style0 from "./POSDefaults.vue?vue&type=style&index=0&id=e541fcaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports